<template>
    <router-view>
        
    </router-view>
</template>
<script>

export default{
    layout:'accounts'
}

</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/accountant/index.vue